import { Listing, TEASER_VERIFICATION } from 'models/Listing';
import AuthContext from 'providers/Auth/Auth.context';
import EnquiryContext from 'providers/Enquiry/Enquiry.context';
import { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import utils from 'utils';

export default function useOpenEnquire() {
  const { isLoggedIn } = useContext(AuthContext);
  const { onEnquire } = useContext(EnquiryContext);

  const navigate = useNavigate();

  return useCallback(
    ({
      _id,
      industry,
      slugName,
      type,
      teaserVerification,
      enableTeaser,
    }: Partial<Listing>) => {
      const needsToBeLoggedIn =
        !isLoggedIn &&
        teaserVerification === TEASER_VERIFICATION.WITH_EMAIL_VERIFICATION;

      const isEnabledTeaser = enableTeaser && !needsToBeLoggedIn;

      const redirectionListingLink = utils.composeBusinessUrl(
        industry,
        slugName,
        type,
      );

      if (isEnabledTeaser) {
        navigate(`${redirectionListingLink}/teaser`);
      } else {
        onEnquire(_id);
      }
    },
    [isLoggedIn, navigate, onEnquire],
  );
}
